import * as Sentry from '@sentry/angular';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ErrorHandler, inject, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TasksFloatingButtonComponent } from '@shared/components/tasks-floating-button/tasks-floating-button.component';
import 'moment/locale/fr';
import { NgxDaterangepickerBootstrapModule, NgxDaterangepickerLocaleService } from 'ngx-daterangepicker-bootstrap';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { MonitoringService } from './core/services/monitoring.service';
import { SharedModule } from './shared/shared.module';
import { SideNavComponent } from './side-nav/side-nav.component';

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [AppComponent, SideNavComponent, TasksFloatingButtonComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    CoreModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWithDelay:10000',
    }),
    NgxDaterangepickerBootstrapModule.forRoot({
      separator: ' - ',
      applyLabel: 'Apply',
      // You can also configure locale, ranges, minDate, maxDate, etc.
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr' },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        maxWidth: '80vw',
        autoFocus: false,
        disableClose: false,
        hasBackdrop: true,
        panelClass: 'custom-dialog',
      },
    },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    NgxDaterangepickerLocaleService,
    provideAppInitializer(() => {
      const monitoringService = inject(MonitoringService);
      monitoringService.initializeUserContext();
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
